import type { GameConfig } from "./types.ts";

/**
 * Default Game Configuration
 * Strongly typed and validated at compile time.
 */
export const DEFAULT_CONFIG: GameConfig = Object.freeze({
  countdownSeconds: 3,
  longPressDurationMs: 650,
  hapticFeedbackMs: 60,
  watermarkText: "CANCELLED",
  preorderEndpoint: "/subscribe"
});
